<script>
import {settingsMethods,settingsComputed} from "@/state/helpers";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  page() {
    // All subcomponent titles will be injected into this template.
    return {
      titleTemplate: this.test
    }
  },
  data() {
    /* eslint-disable no-console */
    return {
      test: ""
    }
  },
  computed: {
    ...settingsComputed
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
    /* eslint-disable no-console */
    this.getSettings()
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
    settings(newSettings){

      this.test=newSettings.title;
    }
  },
  methods: {
    ...settingsMethods,
    testDD(){
      this.test ='Cihan'
    },
    clearNotification: notificationMethods.clear,
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
